<template>
    <!-- content -->
    <section id="content" class="content ques-cont">
        <!--macAddress : {{ macAddress }} modelName {{ modelName }}-->
        <!-- content Header -->
        <div class="content-header sub-visual">
            <div class="sub-visual-bg"></div>
            <div class="in-sec">
                <div class="tit-wrap centered-c">
                	<template v-if="cntryCode != 'IL'"> <!-- // PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
	                    <h2 class="tit-h2">{{ $t('sdp.menu.qna') }}</h2>
	                    <p class="explain-h2" v-html="$t('sdp.support.message.new.qna4_explain')"></p>
	                </template>
	                <template v-if="cntryCode == 'IL'"> <!-- // PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
	                    <h2 class="tit-h2">{{ $t('sdp.menu.qna.Israel') }}</h2>
	                </template>
                </div>
            </div>
        </div>
        <!-- //content Header -->
        <!-- content Body -->
        <div class="content-body">
            <!-- 문의등록 전체영역 -->
            <div class="section-body" v-if="loadingYn == 'Y'">
                <div class="loading-wrap">
                    <div class="loading"><img src="/img/cmn/loading.png" :alt="$t('gwa.alt.common.wa_etc_1')"></div>
                </div>
            </div>
            <div class="ques-regist-wrap in-sec" v-else>
                <!-- 등록 입력영역 -->
                <template v-if="cntryCode != 'IL'"> <!-- // PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
	                <div class="tbl-regist-wrap">
	                    <div class="explain-header">
	                        <p role="text" v-html="$t('sdp.support.message.checkItem', {var1: '<span aria-label=\'필수입력\'>\'<span class=\'txt-required\'>*</span>\'</span>'})"></p>                        
	                    </div>
	                    <!-- 입력정보 -->
	                    <div class="tbl-regist">
	                        <table>
	                            <caption>
	                                <div class="blind-area" role="text">
	                                    <strong v-show="memberYn == 'Y'">{{ $t('gwa.alt.common.wa_caption_3') }}</strong>
	                                    <p>{{ $t('gwa.alt.common.wa_summary_3') }}</p>
	                                </div>
	                            </caption>
	                            <colgroup>
	                                <col class="col-index1">
	                                <col class="col-index2">
	                                <col>
	                            </colgroup>
	                            <tbody>
	                                <!-- CASE 회원등록 -->
	                                <tr v-if="memberYn == 'Y'">
	                                    <th id="registTh1" colspan="2"><span class="form-label">{{ $t('sdp.support.message.idOrEmailId') }}</span></th>
	                                    <td headers="registTh1"><span class="form-static">{{ userId }}</span></td>
	                                </tr>
	                                <!-- //CASE 회원등록 -->
	                                <tr>
	                                    <th id="registTh2" colspan="2"><label class="form-label" role="text">{{ $t('sdp.support.message.recvEmail') }} <span class="txt-required" :aria-label="$t('gwa.alt.common.wa_label_15')">*</span></label></th>
	                                    <td headers="registTh2">
	                                        <div class="grid-form type-email">
	                                            <span class="col"><input type="text" v-model="preEmail" name="preEmail" id="preEmail" value="" placeholder="" :title="$t('gwa.alt.common.wa_title_14')" class="form-text form-size-md" required/></span>
	                                            <span class="col form-split">@</span>
	                                            <span class="col"><input type="text" v-model="endEmail" name="endEmail" id="endEmail" value="" placeholder="" :title="$t('gwa.alt.common.wa_title_15')" class="form-text form-size-md" required/></span>
	                                        </div>
	                                        <!-- CASE 비회원등록 -->
	                                        <div class="link-wrap" v-show="memberYn == 'N'">
	                                            <span class="link-type1 not-link">{{ $t('sdp.inpuiry.message.email_text1') }}</span>
	                                            <button type="button" @click="goLgaccount()" class="btn btn-type5 btn-primary" :aria-label="$t('gwa.alt.common.wa_title_16')" :title="$t('gwa.alt.common.wa_title_16')"><span>{{ $t('sdp.menu.gnb.lgaccount') }}</span></button>
	                                        </div>
	                                        <!-- //CASE 비회원등록 -->
	                                        <div class="form-desc bul bul-star">
	                                            <p>{{ $t('sdp.support.message.qna2') }}</p>
	                                        </div>
	                                    </td>
	                                </tr>
	                            </tbody>
	                            <tbody>
	                                <tr>
	                                    <th id="registTh3" rowspan="3" class="tit-dep1">
	                                        <span v-html="$t('sdp.support.message.type')"></span>
	                                        <div class="btn-group">
												<!-- 2023.06.15 송준형 : REQSDP-2913 - [pcmall] PC website 웹접근성 심사 결과 대응_2023년 -->
	                                            <button type="button" class="btn btn-type5 btn-secondary popup-open" aria-controls="popupQuseAll" aria-haspopup="true" :title="$t('gwa.alt.inquiry.title.001')" :aria-label="$t('gwa.alt.inquiry.title.001')"><span v-html="$t('sdp.support.message.totalView')"></span></button>
	                                        </div>
	                                    </th>
	                                    <th id="registTh31"><label for="cateCode1" role="text">{{ $t('sdp.support.message.catType1') }} <span class="txt-required" :aria-label="$t('gwa.alt.common.wa_label_15')">*</span></label></th>
	                                    <td headers="registTh3 registTh31">
	                                        <span class="form-select form-size-lg">
	                                            <select name="cateCode1" id="cateCode1" @change="changeService($event, 2);" v-model="cateCode1" required>
	                                                <option value="" selected>{{ $t('sdp.support.combo.default') }}</option>
	                                                <option v-for="service in serviceList" :value="service.catCode">{{ service.catName }}</option>
	                                            </select>
	                                        </span>
											<!-- START - C20210408_06760 : 1:1 문의 서비스 항목에 LG Channel 추가 요청드립니다. -->
											<!-- S : 2021.03.18 Add -->
											<div class="lgChannelCsBtn" v-if="lgChannelYn == 'Y'">
												<button type="button" class="btn btn-type5" @click="retrieveFaqInfo('CHANNEL')" :aria-label="$t('gwa.alt.lgchannel.wa_label_1')">{{ $t('sdp.support.btn.lgchannel.001') }}</button>
												<!-- 2025.02.11 송준형 : REQSDP-6592 - [PCMall] lg채널 리스트 site url 업데이트 -->
												<!--<button type="button" class="btn btn-type5" :aria-label="$t('gwa.alt.lgchannel.wa_label_2')" @click="channelDownload()">{{ $t('sdp.support.btn.lgchannel.002') }}</button>-->
												<button type="button" class="btn btn-type5" :aria-label="$t('gwa.alt.lgchannel.wa_label_2')" @click="goChannelListSite()">{{ $t('sdp.support.btn.lgchannel.002') }}</button>
											</div>
											<!-- E : 2021.03.18 Add -->
											<!-- END - C20210408_06760 : 1:1 문의 서비스 항목에 LG Channel 추가 요청드립니다. -->
	                                    </td>
	                                </tr>
	                                <tr>
	                                    <th id="registTh32"><label for="cateCode2" role="text" v-html="$t('sdp.support.message.catType2') + '<span class=\'txt-required\' :aria-label=\'$t(\'gwa.alt.common.wa_label_15\')\'>*</span>'"> </label></th>
	                                    <td headers="registTh3 registTh32">
	                                        <span class="form-select form-size-lg">
	                                            <select name="cateCode2" id="cateCode2" @change="changeService($event, 3);" v-model="cateCode2" required>
	                                                <option value="" selected>{{ $t('sdp.support.combo.default') }}</option>
	                                                <option v-for="category in categoryList" :value="category.catCode">{{ category.catName }}</option>
	                                            </select>
	                                        </span>
	                                    </td>
	                                </tr>
	                                <tr>
	                                    <th id="registTh33"><label for="cateCode3" role="text" v-html="$t('sdp.support.message.catType3') + '<span class=\'txt-required\' :aria-label=\'$t(\'gwa.alt.common.wa_label_15\')\'>*</span>'"></label></th>
	                                    <td headers="registTh3 registTh33">
	                                        <span class="form-select form-size-lg">
	                                            <select name="cateCode3" id="cateCode3" @change="changeType();"  v-model="cateCode3" required>
	                                                <option value="" selected>{{ $t('sdp.support.combo.default') }}</option>
	                                                <option v-for="type in typeList" :value="type.catCode">{{ type.catName }}</option>
	                                            </select>
	                                        </span>
	                                    </td>
	                                </tr>
	                            </tbody>
	                            <!-- 고도화 ver2 : 클래스 tbl-regist-result -->
	
	
								<!--start- N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(Inquiry.vue(문의Main)에서 1:1문의 등록으로 이동-InquiryRegister.vue) 2019.07.11 김남중 -->
								<!-- 모바일 QR코드 -->
								<div class="qrcode-wrap">
									<!-- QR코드스캔 -->
									<div class="qrcode-scan in-sec">
										<div class="inner">
											<h3 class="tit-h3">{{ $t('sdp.qr.message.pop_btn1') }}</h3>
											<p class="para">{{ $t('sdp.qr.message.text5') }}</p>
											<!-- N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(QR코드문구 추가:별표 2019년 이후 출시 모델만 지원 됩니다.) 2019.07.11 김남중 -->
											<p class="label-type5">{{ $t('sdp.qr.message.text6') }}</p>
					
					                        <router-link to="/scanner" tag="button" class="btn btn-type6"><span>{{ $t('sdp.qr.message.pop_btn1') }}</span></router-link>
											<i class="ico ico-qrBg centered-l" aria-hidden="true"></i>
										</div>
									</div>
									<!-- //QR코드스캔 -->
									<!-- QR코드_폴더접기펴기 -->
									<div id="QRGuide" class="qrcode-guide folder-content" aria-hidden="true" data-name="QRGuide"  data-state="closed">
										<!-- QR코드가이드 -->
										<ol class="in-sec">
											<li>
												<div class="item folder-focus" role="text">
													<i class="ico ico-qrImg1 centered-l" aria-label="Guide 1. "></i><span class="txt">{{ $t('sdp.qr.message.text1') }}</span>
												</div>
											</li>
											<li>
												<div class="item" role="text">
													<i class="ico ico-qrImg2 centered-l" aria-label="Guide 2. "></i><span class="txt">{{ $t('sdp.qr.message.text2') }}</span>
												</div>
											</li>
											<li>
												<div class="item" role="text">
													<i class="ico ico-qrImg3 centered-l" aria-label="Guide 3. "></i><span class="txt">{{ $t('sdp.qr.message.text3') }}</span>
												</div>
											</li>
											<li>
												<div class="item" role="text">
													<i class="ico ico-qrImg4 centered-l" aria-label="Guide 4. "></i><span class="txt">{{ $t('sdp.qr.message.text4') }}</span>
												</div>
											</li>
										</ol>
										<!-- //QR코드가이드 -->
									</div>
									<!-- //QR코드_폴더접기펴기 -->
									<!-- QR코드_폴더버튼 -->
									<div class="btn-fold-wrap in-sec centered-b">
										<button type="button" class="btn folder-open" aria-controls="QRGuide" aria-expanded="false" aria-hidden="false" data-role="fold" data-target="QRGuide"><span>{{ $t('sdp.qr.message.btn1') }} <i class="arw arw-toggle4"></i></span></button>
										<button type="button" class="btn folder-close is-active" aria-controls="QRGuide" aria-expanded="true" aria-hidden="true" data-role="fold" data-target="QRGuide"><span>{{ $t('sdp.qr.message.btn2') }} <i class="arw arw-toggle4"></i></span></button>
									</div>
									<!-- //QR코드_폴더버튼 -->
								</div>
								<!-- //모바일 QR코드 -->
								<!--end- N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(Inquiry.vue(문의Main)1:1문의 등록으로 이동-InquiryRegister.vue) 2019.07.11 김남중 -->
	
	
	                            <tbody v-if="typeShow == true" class="tbl-regist-result">
	                                <tr>
	                                    <td colspan="3">
	                                        <!-- 탭영역 -->
	                                        <div class="tab-type1-wrap">
	                                            <!-- 탭메뉴 (퍼블참고 : 검색결과 펼치면서 첫번째 요소에 포커스처리를 위한 클래스 적용 folder-focus) -->
	                                            <!-- 고도화 ver2 : 구조 tit 변경1 -->
	                                            <nav class="tab-nav tab-change tab-type1 tab-cols-2">
	                                                <ul role="tablist">
	                                                    <li role="presentation" class="item1" :class="isDiagActive"><a href="#tabContentSelftest" id="tabContentSelftestNav" class="folder-focus" role="tab" aria-controls="tabContentSelftest" aria-selected="true" aria-expanded="true"><span class="tit">{{ $t('sdp.menu.gnb.self') }}<em class="label-type2">{{ typeDiagCount }}</em></span></a></li>
	                                                    <li role="presentation" class="item2" :class="isFaqActive"><a href="#tabContentFaq" id="tabContentFaqNav" role="tab" aria-controls="tabContentFaq" aria-selected="false" aria-expanded="false"><span class="tit">{{ $t('sdp.menu.faq') }}<em class="label-type2">{{ typeFaqCount }}</em></span></a></li>
	                                                </ul>
	                                            </nav>
	                                            <!-- //탭메뉴 -->
	
	                                            <!-- 탭내용 -->
	                                            <div class="tab-body">
	                                                <!-- 탭내용_자가진단 -->
	                                                <div id="tabContentSelftest" class="tab-content" :class="isDiagActive" aria-labelledby="tabContentSelftestNav">
	                                                    <!-- 자가진단 전체영역 -->
	                                                    <h3 class="blind dv-pc-only">{{ $t('sdp.menu.gnb.self') }}</h3>
	                                                    <div id="selftestAjaxWrap" class="selftest-lists-wrap">
	                                                        <!-- 목록그룹 (대체텍스트 형식 : alt="[제목] + Thumbnail") -->
	                                                        <div class="selftest-lists" data-type="image">
	                                                            <ul>
	                                                                <li v-for="diag in typeDiagList">
	                                                                    <a href="javascript:;" class="item-wrap" :title="$t('gwa.alt.common.wa_title_33')" @click="updateDiagViewCnt(diag.seqNo, diag.catCode1)">
	                                                                        <div role="text">
																				<!-- 2024.06.11 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
	                                                                            <p class="item-thumb thumbnail" aria-hidden="true"><img :src="diag.resourcePth" alt=""></p>
	                                                                            <p class="item-tit"><strong>{{ diag.titleName }}</strong></p>
	                                                                            <p class="item-date">{{ diag.crtDate }}</p>
	                                                                        </div>
	                                                                    </a>
	                                                                    <!--<div class="item-tag" v-if="typeDiagHashTag.length > 0">
	                                                                        <template v-for="hashTag in typeDiagHashTag">
	                                                                            <a href="#" class="tag-type1" role="button" v-if="hashTag.seqNo == diag.seqNo" @click="keywordClick(hashTag.hashTag);">{{ hashTag.hashTag }}</a>
	                                                                        </template>
	                                                                    </div>-->
	                                                                </li>
	                                                            </ul>
	                                                        </div>
	                                                    </div>
	                                                    <!-- //자가진단 전체영역 -->
	                                                    <!-- 미등록게시물 -->
	                                                    <div class="noData-wrap" v-if="typeDiagList.length == 0">
	                                                        <div class="noData">
	                                                            <div class="inner">
	                                                                <p><i class="ico ico-waring2"></i><span class="noData-txt">{{ $t('sdp.support.message.nolist') }}</span></p>
	                                                            </div>
	                                                        </div>
	                                                    </div>
	                                                    <!-- //미등록게시물 -->
	                                                </div>
	                                                <!-- //탭내용 -->
	
	                                                <!-- 탭내용_FAQ -->
	                                                <div id="tabContentFaq" class="tab-content" :class="isFaqActive" aria-labelledby="tabContentFaqNav">
	                                                    <h3 class="blind dv-pc-only">{{ $t('sdp.menu.gnb.faq') }}</h3>
	                                                    <!-- FAQ 전체영역 -->
	                                                    <div id="faqAjaxWrap" class="faq-wrap">
	                                                        <!-- FAQ 목록그룹 -->
	                                                        <div class="accordion-wrap faq-accordion">
	                                                            <!-- 반복영역 -->
	                                                            <div class="accordion" v-for="(faq, index) in typeFaqList">
	                                                                <div class="accordion-title">
																		<!-- 2021.06.28 송준형 : REQSDP-881 - 한국PCMALL 웹접근성 개선 작업요청 -->
	                                                                    <a :href="'#faqContent2_'+index" class="accordion-toggle" role="button" :aria-controls="'faqContent2_'+index" aria-expanded="false" @click="readCntt(faq.seqNo)">
	                                                                        <em class="tit-qusetion" aria-label="Qusetion">Q</em>
	                                                                        <em class="tit-part">{{ faq.catName }}</em>
	                                                                        <span class="tit-label">{{ faq.titleName }}</span>
	                                                                        <i class="arw arw-toggle" aria-hidden="true"></i>
	                                                                    </a>
	                                                                </div>
	                                                                <div :id="'faqContent2_'+index" class="accordion-content" aria-hidden="true">
	                                                                    <em class="tit-answer" aria-label="Answer">A</em>
	                                                                    <div class="data-content" role="text" v-html="lineBreakCntt(faq.cntt)"></div>
	                                                                    <!-- 고도화 ver2 : 속성 aria-label 검색 추가 -->
	                                                                    <div class="tag-wrap">
	                                                                        <template v-for="hashTag in typeFaqHashTag">
	                                                                            <a class="tag-type1" role="button" v-if="hashTag.seqNo == faq.seqNo" @click="keywordClick(hashTag.hashTag);" :aria-label="hashTag.hashTag+' '+$t('gwa.alt.main.sch')">
	                                                                                #{{ hashTag.hashTag }}
	                                                                            </a>
	                                                                        </template>
	                                                                    </div>
	                                                                    <div class="msg-wrap">
	                                                                        <p class="txt-area"><i class="arw arw-right" aria-hidden="true"></i>{{ $t('sdp.Satisfaction.message.question') }}</p>
	                                                                        <div class="btn-area">
	                                                                            <button type="button" class="btn btn-type4 btn-primary" @click="goSatisf('Y')"><span>{{ $t('sdp.Satisfaction.message.btn1') }}</span></button>
	                                                                            <button type="button" class="btn btn-type4 popup-open" aria-controls="popupFaqQuestion" aria-haspopup="true"><span>{{ $t('sdp.Satisfaction.message.btn2') }}</span></button>
	                                                                        </div>
	                                                                    </div>
	                                                                </div>
	                                                            </div>
	                                                            <!-- //반복영역 -->
	                                                        </div>
	                                                    </div>
	                                                    <!-- //FAQ 전체영역 -->
	                                                    <!-- 미등록게시물 -->
	                                                    <div class="noData-wrap" v-if="typeFaqList.length == 0">
	                                                        <div class="noData">
	                                                            <div class="inner">
	                                                                <p><i class="ico ico-waring2"></i><span class="noData-txt">{{ $t('sdp.support.message.nolist') }}</span></p>
	                                                            </div>
	                                                        </div>
	                                                    </div>
	                                                    <!-- //미등록게시물 -->
	                                                </div>
	                                                <!-- //탭내용_FAQ -->
	                                            </div>
	                                            <!-- //탭내용 -->
	                                        </div>
	                                        <!-- //탭영역 -->
	                                    </td>
	                                </tr>
	                            </tbody>
	                            <tbody>
	                                <tr>
	                                    <th id="registTh4" colspan="2"><label>{{ $t('sdp.support.message.maddr') }}</label></th>
	                                    <td headers="registTh4">
	                                        <div class="grid-form type-model">
	                                            <span class="col" v-if="memberYn == 'Y'">
	                                                <span class="form-select form-size-md">
	                                                    <select v-model="macSelectChk" name="sTypes" id="sMacAdd" :title="$t('gwa.alt.common.wa_title_17')" @change="changeMacAddress()">
															<!-- start-2021.04.19 송준형 : C20210419_10922 - Global 1:1문의 시 디바이스정보 자동등록 기능 개선 -->
	                                                        <!--<option value="" selected>{{ $t('sdp.support.combo.default') }}</option>-->
	                                                        <option value="">{{ $t('sdp.support.combo.default') }}</option>
															<template v-for="maddr in maddrList">
																<option :value="maddr.maddr">{{ maddr.maddr }}</option>
															</template>
															<!-- end-2021.04.19 송준형 : C20210419_10922 - Global 1:1문의 시 디바이스정보 자동등록 기능 개선 -->
	                                                        <option value="enterInfo" >{{ $t('sdp.support.message.enterInfo') }}</option>
	                                                    </select>
	                                                </span>
	                                            </span>
												<!-- 2021.04.20 송준형 : C20210419_10922 - Global 1:1문의 시 디바이스정보 자동등록 기능 개선 -->
	                                            <span class="col"><input type="text" v-model="macAddress" name="sMacAdd2" id="sMacAdd2" value="" placeholder="" :title="$t('gwa.alt.common.wa_title_18')" class="form-text form-size-md" :disabled="isDisabled('maddr')" /></span>
	                                        </div>
	                                        <div class="link-wrap">
	                                            <a href="javascript:;" class="link-type1" @click="retrieveFaqInfo('MAC')" :title="$t('gwa.alt.common.wa_title_4')">{{ $t('sdp.support.message.maddrConfirm') }}</a>
	                                        </div>
	                                    </td>
	                                </tr>
	                                <tr>
	                                    <th id="registTh5" colspan="2"><label>{{ $t('sdp.support.message.tvModel') }}</label></th>
	                                    <td headers="registTh5">
	                                        <div class="grid-form type-model">
	                                            <span class="col" v-if="memberYn == 'Y'">
	                                                <span class="form-select form-size-md">
	                                                    <select v-model="modelSelectChk" name="sModel1" id="sModel1" :title="$t('gwa.alt.common.wa_title_19')" @change="changeTvModel()">
															<!-- start-2021.04.20 송준형 : C20210419_10922 - Global 1:1문의 시 디바이스정보 자동등록 기능 개선 -->
	                                                        <!--<option value="" selected>{{ $t('sdp.support.combo.default') }}</option>-->
															<option value="">{{ $t('sdp.support.combo.default') }}</option>
	                                                        <option v-if="modelList.length != 0" :value="modelList.modelName">{{ modelList.modelName }}</option>
															<!-- end-2021.04.20 송준형 : C20210419_10922 - Global 1:1문의 시 디바이스정보 자동등록 기능 개선 -->
	                                                        <option value="enterInfo" >{{ $t('sdp.support.message.enterInfo') }}</option>
	                                                    </select>
	                                                </span>
	                                            </span>
												<!-- 2021.04.20 송준형 : C20210419_10922 - Global 1:1문의 시 디바이스정보 자동등록 기능 개선 -->
	                                            <span class="col"><input type="text" v-model="modelName" name="sModel2" id="sModel2" value="" placeholder="" :title="$t('gwa.alt.common.wa_title_20')" class="form-text form-size-md" :disabled="isDisabled('model')" /></span>
	                                        </div>
	                                        <div class="link-wrap">
	                                            <a href="javascript:;" class="link-type1" @click="retrieveFaqInfo('MODEL')" :title="$t('gwa.alt.common.wa_title_4')">{{ $t('sdp.support.message.tvModelConfirm') }}</a>
	                                        </div>
	                                    </td>
	                                </tr>
	                                <tr>
	                                    <th id="registTh6" colspan="2"><label for="sAPP" role="text">{{ $t('sdp.support.message.serviceName') }} <span class="txt-required" :aria-label="$t('gwa.alt.common.wa_label_15')" v-show="appStoreYn == 'Y'">*</span></label></th>
	                                    <td headers="registTh6">
	                                        <div class="grid-form ac-form-wrap">
	                                            <div class="col">
													<!-- 2021.03.04 송준형 : C20210219_83324 - 1:1문의 페이지에서 Netflix앱 입력 시 ESN 항목 추가 -->
	                                                <input type="text" v-model="appName" name="sAPP" id="sAPP" placeholder="" class="form-text ac-keyword" @keyup="keyPress" @change="checkEsn()"/>
													<!-- S : 2021.02.25 Add 홍병기C -->
													<div class="appnameKeyword" v-if="cntryCode != 'WASU'">
														<button type="button" @click="clickKeyword('Netflix')">#Netflix</button>
														<button type="button" @click="clickKeyword('YouTube')">#YouTube</button>
														<button type="button" @click="clickKeyword('Amazon')">#Amazon Prime Video</button>
													</div>
													<!-- E : 2021.02.25 Add 홍병기C -->
	                                                <!-- Auto Complete -->
	                                                <div class="ac-form ac-search-static2" @click="completeClick()"></div>
	                                                <!-- todo
	                                                <div class="ac-form" v-if="completeCheck == true">
	                                                    <div class="ac-scroll">
	                                                        <ul>
	                                                            <li tabindex="0" v-for="value in completeKeywordList" @click="completeClick(value)" @keyup.enter="completeClick(value)">{{ value }}</li>
	                                                        </ul>
	                                                    </div>
	                                                </div>-->
	                                                <!-- //Auto Complete -->
	                                            </div>
	                                        </div>
	                                    </td>
	                                </tr>
									<!-- S : 2021.02.25 Add 홍병기C : <div class="appnameKeyword"> ~ </div> 영역에서 Netflix 클릭 시 해당 영역 노출 됨 -->
									<!-- 2021.03.04 송준형 : C20210219_83324 - 1:1문의 페이지에서 Netflix앱 입력 시 ESN 항목 추가 -->
									<tr style="display:;" v-if="esnYn == 'Y'">
										<th id="registTh10" colspan="2"><label for="esn1" class="form-label">{{ $t('sdp.support.message.esn') }} <span class="txt-required" :aria-label="$t('gwa.alt.common.wa_label_15')">*</span></label></th>
										<td headers="registTh10">
											<div class="grid-form type-model">
												<!-- START - C20210326_00833 : PC Website 1:1문의 시 Netflix 앱 입력 시 ESN 항목 추가 -->
												<span class="col">
													<!-- 2024.06.12 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
													<input type="text" v-model="esn1" name="esn1" id="esn1" value="" placeholder="" maxlength="9" :title="$t('gwa.alt.common.wa_title_esn1')" class="form-text form-size-md"> <!-- 2021.03.25 Mod -->
												</span>
												<!-- S : 2021.03.25 Add -->
												=
												<span class="col">
													<!-- 2024.06.12 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년 -->
													<input type="text" v-model="esn2" name="esn2" id="esn2" value="" placeholder="" maxlength="11" :title="$t('gwa.alt.common.wa_title_esn2')" class="form-text form-size-md">
												</span>
												<!-- e : 2021.03.25 Add -->
												<!-- END - C20210326_00833 : PC Website 1:1문의 시 Netflix 앱 입력 시 ESN 항목 추가 -->
											</div>
											<div class="link-wrap">
												<a href="javascript:;" class="link-type1" @click="retrieveFaqInfo('ESN')" :title="$t('gwa.alt.common.wa_title_4')">{{ $t('sdp.support.message.esnConfirm') }}</a>
											</div>
										</td>
									</tr>
									<!-- E : 2021.02.25 Add 홍병기C -->
	                                <tr>
	                                    <th id="registTh7" colspan="2"><label for="titleName" role="text">{{ $t('sdp.support.message.title') }} <span class="txt-required" :aria-label="$t('gwa.alt.common.wa_label_15')">*</span></label></th>
	                                    <td headers="registTh7">
	                                        <div class="grid-form">
	                                            <span class="col"><input type="text" v-model="titleName" name="titleName" id="titleName" value="" placeholder="" class="form-text" required/></span>
	                                        </div>
	                                    </td>
	                                </tr>
	                                <tr>
	                                    <th id="registTh8" colspan="2"><label for="tCntt" role="text">{{ $t('sdp.support.message.content') }} <span class="txt-required" :aria-label="$t('gwa.alt.common.wa_label_15')">*</span></label></th>
	                                    <td headers="registTh8">
	                                        <div class="form-textarea-wrap">
	                                            <textarea name="tCntt" id="tCntt" v-model="tCntt" @keyup="checkTextLength($event);" rows="5" cols="30" class="form-textarea" :aria-label="$t('gwa.alt.inquiry.content.info')" required></textarea><!-- 2022.08.30 Mod 홍병기C -->
	                                            <div class="info-area">
	                                                <div class="info-desc">
	                                                    <div class="form-desc bul bul-star">
	                                                        <p>{{ $t('sdp.support.message.qna5') }}</p>
	                                                    </div>
	                                                </div>
	                                                <div class="info-byte">
	                                                    <div class="form-desc bul bul-star">
	                                                        <p>[<span class="byte-now">{{ tCnttLength }}</span>/<span class="byte-total">{{ tMaxLength }}</span>] byte</p>
	                                                    </div>
	                                                </div>
	                                            </div>
	                                        </div>
											<div class="textareaTermsText">{{ $t('gwa.alt.support.inquiry.content.info') }}</div> <!-- 2022.08.30 Add 홍병기C -->
	                                    </td>
	                                </tr>
	                                <tr>
	                                    <th id="registTh9" colspan="2"><label for="files">{{ $t('sdp.support.message.attachment') }}</label></th>
	                                    <td headers="registTh1">
	                                        <div class="form-file" v-show="files.length < 3">
	                                            <!-- <input type="file" ref="files" id="files" value="찾아보기" tabindex="-1" aria-hidden="true" @change="handleFilesUpload()" /> multiple -->
	                                            <input type="file" ref="file0" id="file0" value="찾아보기" :title="$t('gwa.alt.common.wa_title_59')+'1'" tabindex="-1" aria-hidden="true" @change="handleFilesUpload(0)" />
	                                            <input type="file" ref="file1" id="file1" value="찾아보기" :title="$t('gwa.alt.common.wa_title_59')+'1'" tabindex="-1" aria-hidden="true" @change="handleFilesUpload(1)" />
	                                            <input type="file" ref="file2" id="file2" value="찾아보기" :title="$t('gwa.alt.common.wa_title_59')+'1'" tabindex="-1" aria-hidden="true" @change="handleFilesUpload(2)" />
	
	                                            <button type="button" class="btn btn-type3" @click="addFiles()" :aria-label="$t('sdp.support.message.mantoman.attachfile')" aria-describedby="AttachDescription"><span>{{ $t('sdp.support.message.mantoman.attachfile') }}</span></button>
	                                            <!-- 개발참고사항 : 파일목록이 추가된 경우 hidden 속성제거-->
	                                            <span class="form-static" aria-hidden="false" v-if="files.length == 0">{{ $t('sdp.inf.com.noselect') }}</span>
	                                        </div>
	                                        <!-- 개발참고사항 : id, aria-labelledby 연결 (컨트롤요소만 이동하는 경우 기능의 설명이 필요 -->
	                                        <div class="attach-list-wrap" v-if="files.length > 0">
	                                            <ul class="attach-list" id="attach-list">
	                                                <li class="item" v-for="(file, key) in files">
	                                                    <span class="item-label" id="fileItem1" role="text"><i class="ico ico-file" :aria-label="$t('gwa.alt.common.wa_label_16')"></i><span class="txt">{{ file.name }}</span></span>
	                                                    <button type="button" class="btn-ico" aria-labelledby="fileItem1" @click="removeFile(key, file.id)"><span><i class="ico ico-del">{{ $t('gwa.alt.common.wa_label_17') }}</i></span></button>
	                                                    <span class="item-size" role="text"><span :aria-label="$t('gwa.alt.common.wa_label_18')" v-html="convertFileSize(file.size)"></span><!--{{ file.size }}--></span>
	                                                </li>
	                                            </ul>
	                                        </div>
	                                        <div class="form-desc bul bul-star" id="AttachDescription">
	                                            <p>{{ $t('sdp.inpuiry.message.file_text1') }}</p>
	                                            <p>{{ $t('sdp.support.message.fileAttachMsg2') }}</p>
	                                        </div>
	                                    </td>
	                                </tr>
	                            </tbody>
	                        </table>
	                    </div>
	                    <!-- CASE 비회원등록 -->
	                    <div class="explain-footer">
	                        <div class="bul bul-star">
	                            <p>{{ $t('sdp.inpuiry.message.agreed_text1') }}</p>
	                        </div>
	                    </div>
	                    <!-- //CASE 비회원등록 -->
	                </div>
                	<!-- //등록 입력영역 -->

	                <!-- CASE 회원등록 약관동의 -->
					<!-- 2023.12.12 송준형 : REQSDP-2939 - pc mall 1:1 문의 - 비회원 문의 시 약관 확인 건(2023 ISO 지적사항 f/up) -->
	                <div class="terms-wrap">
	                    <!-- //입력정보 표 -->
	                    <div class="explain-header">
	                        <div class="bul bul-star">
	                            <p>{{ $t('sdp.support.message.inquiryChk') }}</p>
	                        </div>
	                    </div>
	                    <div class="terms-body">
	                    <!-- GDPR EEA -->
	                    <div class="terms-group" v-show="gdprFlag == 'Y'">
	                        <div class="terms-content type2">
	                            <div class="terms-inner" v-html="$t('sdp.message.memberjoin.terms.gdpr.overview1')"> <!-- sdp.message.memberjoin.terms.gdpr.overview1 -->
	                            </div>
	                        </div>
	                    </div>
	                    <div class="terms-group" v-show="perTerm.length > 0" v-for="(perData) in perTerm">
	                        <div class="terms-content type2" v-show="gdprFlag == 'Y'">
	                            <div class="terms-inner" v-html="perData.termsCntt">
	                            </div>
	                        </div>
	                        <div class="terms-agree">
	                            <span class="form-check">
	                                <input type="checkbox" name="agree" id="agreeGdpr" v-model="agreeGdpr"/>
	                                <label for="agreeGdpr"><span>{{ $t('sdp.message.memberjoin.terms.gdpr.iagree') }}</span></label> <!--sdp.message.memberjoin.terms.gdpr.iagre-->
	                            </span>
	                        </div>
	                    </div>
	                    <!-- //GDPR EEA -->
	                    <template v-if="langCode == 'KOR'">
	                        <!-- KR -->
							<!-- start-2023.12.12 송준형 : REQSDP-2939 - pc mall 1:1 문의 - 비회원 문의 시 약관 확인 건(2023 ISO 지적사항 f/up) -->
	                        <div class="terms-group" v-for="(prvData, index) in prvTerm">
								<div class="terms-title" v-html="prvData.termsExpln"></div>
	                            <div class="terms-content" role="text">
	                                <div class="terms-inner" tabindex="0"> <!-- 2020.06.10 Mod 홍병기C(웹접근성) -->
										<h6>개인정보 수집 및 이용에 대한 안내 내용 시작</h6> <!-- 2020.06.10 Add 홍병기C(웹접근성) : 약관 내용 시작과 끝에 '약관 타이틀 + 내용 시작 또는 끝'으로 표기 -->
										<div v-html="prvData.termsCntt"></div>
										<h6>개인정보 수집 및 이용에 대한 안내 내용 끝</h6> <!-- 2020.06.10 Add 홍병기C(웹접근성) : 약관 내용 시작과 끝에 '약관 타이틀 + 내용 시작 또는 끝'으로 표기 -->
	                                </div>
	                            </div>
	                            <div class="terms-agree">
	                                <span class="form-check">
	                                    <input type="checkbox" name="agree" id="agreeKOR1" v-model="agreeKOR1" v-if="index == 0"/>
	                                    <label v-show="index == 0" for="agreeKOR1"><span>{{ $t('sdp.support.message.agreeMsg2') }}</span></label>
	                                    <!--<input type="checkbox" name="agree" id="agreeKOR2" v-model="agreeKOR2" v-if="index == 1"/>-->
	                                    <!--<label v-show="index == 1" for="agreeKOR2"><span>{{ $t('sdp.support.message.agreeMsg2') }}</span></label>-->
	                                </span>
	                            </div>
	                        </div>
							<!-- end-2023.12.12 송준형 : REQSDP-2939 - pc mall 1:1 문의 - 비회원 문의 시 약관 확인 건(2023 ISO 지적사항 f/up) -->
	                    </template>
	                    <template v-else>
							<!-- start-2023.12.12 송준형 : REQSDP-2939 - pc mall 1:1 문의 - 비회원 문의 시 약관 확인 건(2023 ISO 지적사항 f/up) -->
							<div class="terms-group">
								<div class="terms-content type2">
									<div class="terms-inner" v-html="$t('sdp.support.message.inquiryTermsMsg')"></div>
								</div>
								<div class="terms-agree" v-show="gdprFlag == 'Y'">
									<span class="form-check">
										<input type="checkbox" name="agree" id="agreeGdprTerms" v-model="agreeGdprTerms"/>
										<label for="agreeGdprTerms"><span>{{ $t('sdp.message.memberjoin.terms.gdpr.iagree') }}</span></label>
									</span>
								</div>
							</div>
							<!-- end-2023.12.12 송준형 : REQSDP-2939 - pc mall 1:1 문의 - 비회원 문의 시 약관 확인 건(2023 ISO 지적사항 f/up) -->
	                        <!-- KR이 아니면서 GDPR 국가 -->
	                        <div class="terms-group" v-show="gdprFlag == 'Y'" v-for="(prvData, index) in prvTerm">
	                            <div class="terms-title" v-show="index == 0">
	                                {{ $t('sdp.message.memberjoin.terms.gdpr.title4') }}
	                            </div>
	                            <div class="terms-title" v-show="index == 1">
	                                {{ $t('sdp.menu.device.menutop2.gdpr.04') }}
	                            </div>
	                            <div class="terms-content" role="text">
									<div class="terms-inner" v-html="prvData.termsCntt" tabindex="0"> <!-- 2020.06.10 Mod 홍병기C(웹접근성) -->
									</div>
	                            </div>
	                        </div>
	                        <!-- KR이 아니면서 GDPR가 아닌 국가 -->
	                        <div class="terms-group" v-show="gdprFlag == 'N'" v-for="(prvData, index) in prvTerm">
	                            <div class="terms-title">
	                                {{ $t('sdp.support.message.agreeMsg1') }}
	                            </div>
	                            <div class="terms-content" role="text">
	                                <div class="terms-inner" v-html="prvData.termsCntt" tabindex="0"> <!-- 2020.06.10 Mod 홍병기C(웹접근성) -->
	                                </div>
	                            </div>
	                            <div class="terms-agree">
	                                <span class="form-check">
	                                    <input type="checkbox" name="agree" id="agreeNotKOR" v-model="agreeNotKOR"/>
	                                    <label v-show="index == 0" for="agreeNotKOR"><span>{{ $t('sdp.support.message.agreeMsg2') }}</span></label>
	                                </span>
	                            </div>
	                        </div>
	                    </template>
	                </div>
	                </div>
	                <!-- //CASE 회원등록 약관동의 -->

	                <!-- 등록 버튼영역 -->
	                <div class="btn-wrap align-c">
	                    <div class="btn-group">
	                        <!-- N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의) 2019.07.11 김남중 -->
	                        <!-- <span class="col"><router-link to="/main/inquiry/register" tag="button" type="button" class="btn btn-type1" :aria-label="$t('gwa.alt.support.inquiry.cancel.001')"><span>{{ $t('sdp.support.message.cancel') }}</span></router-link></span> -->
	                        <span class="col"><button type="button" @click="inquiryCancel();" class="btn btn-type1" :aria-label="$t('gwa.alt.support.inquiry.cancel.001')"><span>{{ $t('sdp.support.message.cancel') }}</span></button></span>
	                        <span class="col"><button type="button" @click="inquiryCheck();" class="btn btn-type1 btn-primary" :aria-label="$t('gwa.alt.support.inquiry.confirm.001')"><span>{{ $t('sdp.support.message.submit') }}</span></button></span>
	                    </div>
	                </div>
	                <!-- //등록 버튼영역 -->
                </template> <!-- // end-PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
                
                <!-- // start-PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
                <template v-if="cntryCode == 'IL'">
                    <!-- 상세그룹 -->
					<div class="ques-detail-wrap in-sec">
						<div class="csTelephone textRtL">
							<div class="title">התקשר לנציג תמיכת LG</div>
							<div class="csTelephone_wrap">
								<ul>
									<li class="time">ראשון עד חמישי<br>שישי-שבת , ערבי חג וימי חג: סגור</li>
									<li class="tel">התקשר לנציג של LG בטלפון<br>1-700-50-60-54<br>(עלות שיחה רגילה)</li>
									<li class="tel">ברימג שירות 8404* (03-6530200)<br>ישנם מרכזי שירות בכל רחבי הארץ, לכולם ניתן להגיע תחת מספר הטלפון המצויין מעלה.<br>סניף במרכז -הבנאי 12, חולון<br>סניף בצפון - ההסתדרות 88, חיפה<br>סניף בדרום - הנגרים 4, באר שבע<br>סניף בירושלים- כנפי נשרים 24, ירושלים<br>סניף באילת- הבנאי 3, אילת<br>כל הסניפים מציעים שירות לכלל המוצרים המשווקים ע"י ברימג</li>
									<li class="tel">ח.י אלקטרוניקה 1-700-70-11-15<br>השירות ניתן בבית הלקוח לאחר תיאום טלפוני.<br>מספר WhatsApp לשירות- 052-444-2649</li>
									<li>רונלייט- 04-998-5919<br>השירות ניתן בכתובת בר כוכבא 21, בני ברק<br>ישנן נקודות שירות נוספות ברחבי הארץ, עליהן ניתן לברר במספר הטלפון המצויין מעלה.</li>
									<li class="tel">ברימג מערכות- 1-700-50-22-11<br>יש ליצור קשר עם מרכז השירות בטלפון המופיע מעלה.</li>
								</ul>
							</div>
						</div>
					</div>
					<!-- //상세그룹 -->
                </template>
                <!-- // end-PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
                
            </div>
            <!-- //문의등록 전체영역 -->

            <!-- 팝업_만족도조사 -->
            <FaqSatisfPop></FaqSatisfPop>
            <!-- //팝업_만족도조사 -->

            <!-- 팝업_문의등록확인 -->
            <!-- N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의-문의등록후dimmer처리되어 추가, component사용하지 않고 div로 처리) 2019.07.11 김남중 -->
            <InquiryRegisterConfirmPop></InquiryRegisterConfirmPop>
            <!-- //팝업_문의등록확인 -->

            <!-- 팝업_약관체크확인 -->
            <!--<InquiryTermValidationPop></InquiryTermValidationPop>-->
            <div id="popupTermValidation" class="popup-wrap" hidden> 
                <div class="popup popup-type1" role="dialog" aria-labelledby="popupTermValidationTitle">
                    <div class="blind-area popup-focus dv-ios-only" role="text" :aria-label="$t('gwa.alt.inquiry.wa_label_1')"><!-- IOS접근성 영역자체에 초점처리 --></div>
                    <div class="popup-container">
                        <div class="popup-header">
                        	<!-- C20190723_47503 : 2019.08.08 김남중 - Safari 에서 javascript:; 미지원으로 terms/privacy뜨지 않는 오류 개선 (별도 csr 없이 N20190722_09499 이 csr과 함께 반영) -->
                        	<!-- 한국 + GDPR = N -->
                            <!-- <h3 class="tit-h3" v-if="termValidate != 'agreeGdpr'">{{ $t('gwa.alt.member.layerpopupagreeterm') }}</h3> -->
                            <!-- GDPR = Y -->
                            <!-- <h3 class="tit-h3" v-else>{{ $t('sdp.memberterm.policy.gdpr.inquiry.title') }}</h3> -->
                            <h3 class="tit-h3"></h3>
                        </div>
                        <div class="popup-body popup-scroll">
                            <div class="para-wrap">
                                <!-- 한국 - 취급위탁 -->
                                <p class="para color-primary" v-if="termValidate == 'agreeKOR1'">{{ $t('refund.agree.message.confirm') }}</p>
                                <!-- 한국 - 개인정보 -->
                                <p class="para color-primary" v-if="termValidate == 'agreeKOR2'">{{ $t('gwa.alt.member.regist.terms10') }}</p>
                                <!-- GDPR 국가 -->
                                <p class="para color-primary" v-if="termValidate == 'agreeGdpr'">{{ $t('sdp.memberterm.policy.gdpr.inquiry') }}</p>
                                <!-- GDPR 및 한국 이외의 국가 -->
                                <p class="para color-primary" v-if="termValidate == 'agreeNotKOR'">{{ $t('sdp.memberterm.policy') }}</p>
                            </div>
                        </div>
                        <div class="popup-footer">
                            <div class="btn-wrap">
                                <button type="button" class="btn btn-type2 popup-close btn-secondary" aria-controls="popupTermValidation"  :title="$t('gwa.alt.common.wa_title_56')"><span>{{ $t('sdp.message.layerpopup.close') }}</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- //팝업_약관체크확인 -->
            <!-- 팝업_문의구분_전체보기 -->
            <InquiryAllCategoryPop></InquiryAllCategoryPop>
            <!-- //팝업_문의확인 -->
            
            <!--start- N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의 및 Inquiry.vue(문의Main)1:1문의 등록으로 이동-InquiryRegister.vue) 2019.07.11 김남중 -->
            <!-- 모달팝업_문의확인 -->
			<div v-show="memberYn == 'N' && cntryCode != 'IL'"> <!-- // PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
			<!-- <div v-show="memberYn == 'N'"> -->
				<InquiryConfirmPop class="popup-wrap" hidden></InquiryConfirmPop>
			</div>
			<div v-show="noticeYn == 'Y'"> <!-- // [UI기획]PC Website 1:1문의 대응 지연 팝업 문구 안내 건 - N20200420_06622 : 2020.04.20 송준형 -->
				<InquiryMemberNoticePop class="popup-wrap" hidden></InquiryMemberNoticePop>
			</div>
			<!-- //모달팝업_문의확인 -->
			<!-- QR코드_촬영 -->
            <InquiryQRCodeScanPop ref="qrcodeScanPop"></InquiryQRCodeScanPop>
            <!-- //QR코드_촬영 -->
			<!--end- N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의 및 Inquiry.vue(문의Main)1:1문의 등록으로 이동-InquiryRegister.vue) 2019.07.11 김남중 -->

			<!-- 팝업_FR국가 법적고지(NOTES JURIDIQUES) PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
			<div v-show="cntryCode == 'FR'">
				<TermsPop></TermsPop>
			</div>
			<!-- //팝업_FR국가 법적고지(NOTES JURIDIQUES) PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중 -->
			
        </div>
        <!-- //content Body -->
    </section>
    <!-- //content -->
</template>

<style>
</style>

<script>

    import qs from "qs";
    import InquiryRegisterConfirmPop from '@/components/inquiry/InquiryRegisterConfirmPop';
    import FaqSatisfPop from '@/components/faq/FaqSatisfPop';
    import InquiryAllCategoryPop from '@/components/inquiry/InquiryAllCategoryPop';
    import InquiryConfirmPop from '@/components/inquiry/InquiryConfirmPop';       // N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의) 2019.07.11 김남중
    import InquiryQRCodeScanPop from '@/components/inquiry/InquiryQRCodeScanPop'; // N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의 및 Inquiry.vue(문의Main)1:1문의 등록으로 이동-InquiryRegister.vue)
    import InquiryMemberNoticePop from '@/components/inquiry/InquiryMemberNoticePop'; // N20200420_06622-[UI기획]PC Website 1:1문의 대응 지연 팝업 문구 안내 건 2020.04.20 송준형
    import TermsPop from '@/components/terms/TermsPop';

    export default {
        name: "inquiryRegister",
        components: {
            InquiryRegisterConfirmPop,
            FaqSatisfPop,
            InquiryAllCategoryPop,
            InquiryConfirmPop,    // N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의) 2019.07.11 김남중
            InquiryQRCodeScanPop, // N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의 및 Inquiry.vue(문의Main)1:1문의 등록으로 이동-InquiryRegister.vue)
            InquiryMemberNoticePop, // N20200420_06622-[UI기획]PC Website 1:1문의 대응 지연 팝업 문구 안내 건 2020.04.20 송준형
            TermsPop //PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중
        },
        data() {
            return {
                preEmail : "", // 비회원 이메일
                endEmail : "", // 비회원 이메일
                userId : "", // 회원 아이디
                email : "", // 회원 이메일
                maddrList : [],
                modelList : [],
                macAddress : "", // MAX Address
                modelName : "", // TV Model No
                maddrYn : "N",
                modelYn : "N",
                appName : "", // appName
                titleName : "", // 제목
                tCntt : "", // 내용
                files : [], // 첨부파일
                serviceList : [], // 서비스
                categoryList : [], // 항목
                typeList : [], // 유형
                typeFaqList : [],
                typeDiagList : [],
                typeFaqHashTag : [],
                typeDiagHashTag : [],
                typeFaqCount : 0,
                typeDiagCount : 0,
                typeShow : false,
                memberYn : "Y",
				noticeYn : "N",
                macInfoSeq : 0,
                modelInfoSeq : 0,
                esnInfoSeq : 0, // 2021.03.09 송준형 : C20210219_83324 - 1:1문의 페이지에서 Netflix앱 입력 시 ESN 항목 추가
                cateCode1 : "", // 서비스
                cateCode2 : "", // 항목
                cateCode3 : "", // 유형
                // 약관  -------- 비회원
                perTerm : [],
                perTermSize : 0,
                prvTerm : [],
                prvTermSize : [],
                langCode : "",
                gdprFlag : "N",
                gdprTermsData : false,
                agreeNotKOR : false, // KR이 아닐 경우 약관 체크
                agreeKOR1 : false, // KR일 경우 1 약관 체크
                agreeKOR2 : false, // KR일 경우 2 약관 체크
                agreeGdpr : false, // GDPR 국가 약관 체크
                agreeGdprTerms : false, // 2023.12.12 송준형 : REQSDP-2939 - pc mall 1:1 문의 - 비회원 문의 시 약관 확인 건(2023 ISO 지적사항 f/up)
                tCnttLength : 0,
                tMaxLength : 4000,
                sMaxLength : 500,
				cnttMinLength : 30, // 2020.07.27 송준형 : C20200717_71055 - PC Website 1:1문의 개선(1:1문의 입력시 최소 Byte 설정)
                titleClickYn: "N",
                appStoreYn : "N",
                termValidate : "",
                loadingYn: "N",
                diagActiveYn : true,
                completeKeywordList : [],
                completeCheck : false,
                macSelectChk : "",
                modelSelectChk : "",
                facebkFlag : "",
                thirdpartyFlag : "",
                esnYn: "N", // 2021.03.04 송준형 : C20210219_83324 - 1:1문의 페이지에서 Netflix앱 입력 시 ESN 항목 추가
                esn1: "", // 2021.03.26 송준형 : C20210326_00833 - PC Website 1:1문의 시 Netflix 앱 입력 시 ESN 항목 추가
                esn2: "", // 2021.03.26 송준형 : C20210326_00833 - PC Website 1:1문의 시 Netflix 앱 입력 시 ESN 항목 추가
                lgChannelYn: "N", // 2021.04.08 송준형 : C20210408_06760 - 1:1 문의 서비스 항목에 LG Channel 추가 요청드립니다.
                inquiryChannelCode: "", // 2021.04.08 송준형 : C20210408_06760 - 1:1 문의 서비스 항목에 LG Channel 추가 요청드립니다.
                faqChannelCode: "", // 2021.04.08 송준형 : C20210408_06760 - 1:1 문의 서비스 항목에 LG Channel 추가 요청드립니다.
                channelDownloadUrl: "", // 2021.04.13 송준형 : C20210408_06760 - 1:1 문의 서비스 항목에 LG Channel 추가 요청드립니다.
                selectedMaddr: "", // 2021.04.19 송준형 : C20210419_10922 - Global 1:1문의 시 디바이스정보 자동등록 기능 개선
                maddrNoticeYn: "N", // 2021.04.20 송준형 : C20210419_10922 - Global 1:1문의 시 디바이스정보 자동등록 기능 개선
                cntryCode: _domainCntryCode
            }
        },
        created() {
        },
        destroyed() {
        },
        watch: {
        },
        computed: {
            isDiagActive () {
                if (this.diagActiveYn) {
                    return "is-active";
                } else {
                    return "";
                }
            },
            isFaqActive () {
                if (this.diagActiveYn == false) {
                    return "is-active";
                } else {
                    return "";
                }
            }
        },
        methods: {
            track () {
				console.log('@@@@ track:', this.$router.currentRoute.path);
				this.$ga.page(this.$router.currentRoute.path)
			},
			//start- N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의 및 Inquiry.vue(문의Main)1:1문의 등록으로 이동-InquiryRegister.vue)
			openQRCodeScanPop() {
                console.log('openQRCodeScanPop..');
                this.$refs.qrcodeScanPop.open();
            },
            closeQRCodeScanPop() {
                console.log('closeQRCodeScanPop..')
                this.$refs.qrcodeScanPop.close();
            },
            //end- N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의 및 Inquiry.vue(문의Main)1:1문의 등록으로 이동-InquiryRegister.vue)
            keyPress(e) {
                // arrow key down, up
                if(e.which == 40 || e.which == 38 ) {
                    return;
                } else if (e.which == 13) {
                    this.appName = $('#sAPP').val();
                    // start-2021.04.07 송준형 : C20210407_06423 - ESN key 반영 기능 수정 요청드립니다.
                    if(this.cntryCode != "WASU" && this.appName == "Netflix") {
                        this.esnYn = "Y";
                    } else {
                        this.esnYn = "N";
                        this.esn1 = "";
                        this.esn2 = "";
                    }
                    // end-2021.04.07 송준형 : C20210407_06423 - ESN key 반영 기능 수정 요청드립니다.
                } else {
                    this.autoSearchText();
                }
            },
            goLgaccount() {
                // 2024.12.17 송준형 : REQSDP-6333 - PCMall LMP(멤버스) 로그인 연동 방식 개선 개발
                var loginPath = "inquiry/register";
                const r = { path : "/main/loginLink?path=" + loginPath };
                this.$router.push(r);
            },
            isDisabled (type) {
                if (type == 'maddr') {
                    if (this.memberYn == "Y" && this.maddrYn == 'N') {
                        return true;
                    } else {
                        return false;
                    }
                } else if (type == 'model') {
                    if (this.memberYn == "Y" && this.modelYn == 'N') {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    if (this.satisf.rsnType == "ETC") {
                        return false;
                    } else {
                        return true;
                    }
                }
            },
            changeService(event, lowLevelNo) {
                const vm = this;

                // 초기화
                if (lowLevelNo == 2) {
                    vm.categoryList = [];
                    vm.cateCode2 = "";
                    if (event.target.value == 1003) { // 앱 스토어 / 콘텐츠일 경우 서비스명 필수값
                        vm.appStoreYn = 'Y'
                    } else {
                        vm.appStoreYn = 'N'
                    }
					if (event.target.value == vm.inquiryChannelCode) { // 2021.04.08 송준형 : C20210408_06760 - 1:1 문의 서비스 항목에 LG Channel 추가 요청드립니다.
					    vm.lgChannelYn = 'Y';
					} else {
					    vm.lgChannelYn = 'N';
					}
                }
                vm.typeList = [];
                vm.cateCode3 = "";
                vm.searchType = "";

                const params = {
                    highCatCode: event.target.value,
                    catLevelNo: lowLevelNo
                };
                this.$axios.post("/api/inquiry/retrieveInquiryCategoryList.ajax", qs.stringify(params)).then((result) => {
                    if(lowLevelNo == 2) {
                        vm.categoryList = result.data.categoryList;
                    }
                    if(lowLevelNo == 3) {
                        vm.typeList = result.data.categoryList;
                    }
                }).catch((error) => {
                    alert("error");
                });
            },
            changeType() {
                const vm = this;

                const params = {
                    perQuestCatCode : vm.cateCode3
                };

                this.$axios.post("/api/inquiry/retrieveInquiryTypeList.ajax", qs.stringify(params)).then((result) => {

                    vm.typeFaqList = result.data.faqList;
                    vm.typeDiagList = result.data.diagList;
                    vm.typeFaqCount = result.data.faqCount;
                    vm.typeDiagCount = result.data.diagCount;

                    if (vm.typeFaqList.length > 0) {
                        vm.typeFaqHashTag = result.data.faqHashTag;
                    }

                    if (vm.typeDiagList.length > 0) {
                        vm.typeDiagHashTag = result.data.diagHashTag;
                    }

                    if (vm.typeDiagList.length > 0) {
                        vm.diagActiveYn = true;
                    } else {
                        if (vm.typeFaqList.length > 0) {
                            vm.diagActiveYn = false;
                        } else {
                            vm.diagActiveYn = true;
                        }
                    }

                    if (vm.typeFaqList != null || vm.typeDiagList != null) {
                        vm.typeShow = true; // 항목 리스트 노출
                    }

                    vm.$nextTick(function() {
                        ui.tab.init();
                        ui.faqAccordion.init();
                    });

                }).catch((error) => {
                    alert("error");
                });
            },
            channelDownload() { // 2021.04.13 송준형 : C20210408_06760 - 1:1 문의 서비스 항목에 LG Channel 추가 요청드립니다.
                var filePath = this.channelDownloadUrl;
                if(filePath != "") {
                    window.location = filePath;
				}
			},
            goChannelListSite() { // 2025.02.11 송준형 : REQSDP-6592 - [PCMall] lg채널 리스트 site url 업데이트
                var siteUrl = "https://channel-lineup.lgchannels.com";

                // window navigator
                var userAgent = window.navigator.userAgent;
                var isChrome = userAgent.indexOf('Chrome');
                var isChromeMobile = userAgent.indexOf('CriOS');
                var isSamsungBrowser = userAgent.indexOf('SamsungBrowser');
                var isFirefox = userAgent.indexOf('Firefox');
                var isEdge = userAgent.indexOf('Edge');
                var browse = userAgent.toLowerCase();
                var isIe = browse.indexOf("msie");
                var isIeMinu = browse.indexOf("trident");

                // window Open
                var popWindow;
                var baseWinurl = window.location;
                if ((navigator.appName == 'Netscape' && isIeMinu > -1) || isIe > -1) {}
                else if (isSamsungBrowser > -1) { popWindow = window.open(); }
                else if (isChrome > -1 || isFirefox > -1) { popWindow = window.open(baseWinurl, '_blank'); }
                else { popWindow = window.open('_blank'); }

                if ((navigator.appName == 'Netscape' && isIeMinu > -1) || isIe > -1) {
                    window.open(siteUrl, '_blank');
                } else {
                    popWindow.location.href = siteUrl;
                }
			},
            changeMacAddress() {

                if (event.target.value == 'enterInfo') {
                    this.maddrYn = 'Y';
                    isDisabled ('maddr');
                } else if (event.target.value != ''){

                    this.macAddress = event.target.value;

                    const params = {
                        maddr: this.macAddress,
                    };

                    this.$axios.post("/api/inquiry/retrieveModelList.ajax", qs.stringify(params)).then((result) => {
                        this.modelList = result.data.modelList;
                    }).catch((err) => {
                        alert("error : " + err);
                    });
                }

            },
            changeTvModel() {

                if (event.target.value == 'enterInfo') {
                    this.modelYn = 'Y';
                    isDisabled ('model');
                } else {
                    this.modelName = event.target.value;
                }

            },
            readCntt(seqNo) {
                this.$store.state.faqSeqNo = seqNo;
                this.$store.state.satisfType = 'faq';

                const vm = this;
                if(seqNo != vm.faqSeqNo) {
                    vm.faqSeqNo = seqNo;
                    vm.updateViewCnt(seqNo);
                } else {
                    if(vm.titleClickYn == 'Y') {
                        vm.titleClickYn = 'N';
                    } else {
                        vm.updateViewCnt(seqNo);
                    }
                }
            },
            goSatisf(clickType) {
                const vm = this;

                const params = {
                    clickType: clickType,
                    faqSeqNo: vm.faqSeqNo
                };

                this.$axios.post("/api/faq/mergeFaqSatisf.ajax",
                    qs.stringify(params)).then((result) => {
                    alert(this.$t('sdp.Satisfaction.message.pop_text6'));
                }).catch((err) => {
                    alert("error : " + err);
                });
            },
            updateDiagViewCnt(seqNo, catCode1) {
                const vm = this;
                vm.diagSeqNo = seqNo;
                vm.diagCatCode1 = catCode1;

                const params = {
                    seqNo: vm.diagSeqNo
                };

                this.$axios.post("/api/diag/updateDiagViewCnt.ajax",
                    qs.stringify(params)).then((result) => {
                    const r = { path : "/main/diag/detail?seqNo=" + vm.diagSeqNo + "&catCode1="
                    + vm.diagCatCode1 + "&searchYn=N&allClickYn=N&schTxt=&curPage=1" };
                    this.$router.push(r);
                }).catch((err) => {
                    alert("error : " + err);
                });
            },
            updateViewCnt(seqNo) {
                const vm = this;
                const params = {
                    seqNo: seqNo
                };
                this.$axios.post("/api/faq/updateFaqViewCnt.ajax", qs.stringify(params)).then((result) => {
                    vm.titleClickYn = 'Y';
                }).catch((err) => {
                    alert("error : " + err);
                });
            },
            retrieveFaqInfo (type) {
                if (type == 'MAC') {
                    const macUrl = window.location.protocol + "//" + window.location.host + '/main/faq?seqNo=' + this.macInfoSeq;
                    window.open(macUrl, '_blank');
                    /*const r = { path : `/main/faq?seqNo=${this.macInfoSeq}`};
                    this.$router.push(r);*/
                } else if(type == 'MODEL') { // 2021.03.09 송준형 : C20210219_83324 - 1:1문의 페이지에서 Netflix앱 입력 시 ESN 항목 추가
                    const modelUrl = window.location.protocol + "//" + window.location.host + '/main/faq?seqNo=' + this.modelInfoSeq;
                    window.open(modelUrl, '_blank');
                    /*const r = { path : `/main/faq?seqNo=${this.modelInfoSeq}`};
                    this.$router.push(r);*/
                } else if(type == 'ESN') { // 2021.03.09 송준형 : C20210219_83324 - 1:1문의 페이지에서 Netflix앱 입력 시 ESN 항목 추가
                    const esnUrl = window.location.protocol + "//" + window.location.host + '/main/faq?seqNo=' + this.esnInfoSeq;
                    window.open(esnUrl, '_blank');
                    /*const r = { path : `/main/faq?seqNo=${this.esnInfoSeq}`};
                    this.$router.push(r);*/
				} else { // 2021.04.08 송준형 : C20210408_06760 - 1:1 문의 서비스 항목에 LG Channel 추가 요청드립니다.
                    const channelUrl = window.location.protocol + "//" + window.location.host + '/main/faq?catCode1=' + this.faqChannelCode;
                    window.open(channelUrl, '_blank');
                    /*const r = { path : `/main/faq?catCode=${this.faqChannelCode}`};
                    this.$router.push(r);*/
                }
            },
            checkSubjectLength (subject) {
                var strLength = this.getStrByte(subject);
                if (strLength > this.sMaxLength) {
                    return true;
                } else {
                    return false;
                }
            },
            checkTextLength (event) {
                var strValue = event.target.value;
                var strLength = this.getStrByte(event.target.value);

                /*alert(event.target.value);*/
                if (strLength <= this.tMaxLength) {
                    this.tCnttLength = strLength;
                } else {
                    strValue = this.strCutByByte(strValue, this.tMaxLength);
                    strLength = this.getStrByte(strValue);
                    this.tCntt = strValue;
                    this.tCnttLength = strLength;

                    return;
                }
            },
            strCutByByte (str, max) {
                var byteLength = 0;
                var result = "";

                for (var inx = 0; inx < str.length; inx++) {
                    var oneChar  = str.charAt(inx);
                    var charCode = oneChar.charCodeAt(0);
                    if(charCode)
                        if(charCode != 13){
                            if (charCode <= 0x00007F) {
                                byteLength ++;
                            }else if (charCode <= 0x0007FF) {
                                byteLength += 2;
                            }else if (charCode <= 0x00FFFF) {
                                byteLength += 3;
                            } else {
                                byteLength += 4;
                            }
                        }

                    if (byteLength > max) {
                        break;
                    }
                    result = result + str.charAt(inx);
                }

                return result;
            },
            getStrByte(value) {

                console.log('getStrByte ' + 'Enter');
                var byteLength = 0, ch;
                var charCode;
                var len = value.length;
                for(var i = 0; i < len; i++) {
                    ch = value.charAt(i);
                    charCode = ch.charCodeAt(0);
                    if(charCode)
                        if(charCode != 13){ // enter값이 2번 넘어온다.10,13 10번은 화면 test 시  나오지만 13번은 나오지 않아 13번을 막음.
                            if (charCode <= 0x00007F) {
                                byteLength ++;
                            }else if (charCode <= 0x0007FF) {
                                byteLength += 2;
                            }else if (charCode <= 0x00FFFF) {
                                byteLength += 3;
                            } else {
                                byteLength += 4;
                            }
                        }
                }
                return byteLength;
            },
            clickKeyword(keyword) { // 2021.03.04 송준형 : C20210219_83324 - 1:1문의 페이지에서 Netflix앱 입력 시 ESN 항목 추가
                var appKeyword = keyword;
                if(keyword == "Netflix") {
                    this.esnYn = "Y";
				} else {
                    this.esnYn = "N";
                    this.esn1 = ""; // 2021.03.29 송준형 : C20210326_00833 - PC Website 1:1문의 시 Netflix 앱 입력 시 ESN 항목 추가
                    this.esn2 = ""; // 2021.03.29 송준형 : C20210326_00833 - PC Website 1:1문의 시 Netflix 앱 입력 시 ESN 항목 추가
                    if(keyword == "Amazon") {
                        appKeyword = "Amazon Prime Video";
                    }
				}
				this.appName = appKeyword;
			},
            checkEsn() { // 2021.03.04 송준형 : C20210219_83324 - 1:1문의 페이지에서 Netflix앱 입력 시 ESN 항목 추가
                if(this.esnYn == "Y" && this.appName != "Netflix") {
                    this.esnYn = "N";
                    this.esn1 = ""; // 2021.03.29 송준형 : C20210326_00833 - PC Website 1:1문의 시 Netflix 앱 입력 시 ESN 항목 추가
                    this.esn2 = ""; // 2021.03.29 송준형 : C20210326_00833 - PC Website 1:1문의 시 Netflix 앱 입력 시 ESN 항목 추가
				}
			},
            completeClick() {
                this.appName =  $('#sAPP').val();
                // start-2021.04.07 송준형 : C20210407_06423 - ESN key 반영 기능 수정 요청드립니다.
                if(this.cntryCode != "WASU" && this.appName == "Netflix") {
                    this.esnYn = "Y";
                } else {
                    this.esnYn = "N";
                    this.esn1 = "";
                    this.esn2 = "";
                }
                // end-2021.04.07 송준형 : C20210407_06423 - ESN key 반영 기능 수정 요청드립니다.
            },
            autoSearchText() {

                const keyword = $('#sAPP').val().toLowerCase();

                var params = {
                    searchText : keyword
                };

                const vm = this;

                this.$axios.post("/api/integratedSearch/retrieveAutoSearch.ajax", qs.stringify(params)).then((result) => {

                    if(result.data.completeKeywordList == undefined) {
                        vm.completeKeywordList = []
                    } else {
                        vm.completeKeywordList = result.data.completeKeywordList;
                    }

                    $("#sAPP").autocomplete("option", "source", vm.completeKeywordList);
                    $("#sAPP").autocomplete( "search", keyword );

                    /*this.$nextTick(function() {
                        vm.completeKeywordList = result.data.completeKeywordList;
                        console.log("completeKeywordList", vm.completeKeywordList);

                        $("#sAPP").autocomplete({
                            appendTo: ".ac-search-static2",
                            source : vm.completeKeywordList,
                            messages: {
                                noResults: '',
                                results: function() {}
                            }
                        });
                    })*/
                }).catch((error) => {
                    alert("error");
                });
            },
            handleFilesUpload(id) {
                let uploadFiles = this.$refs['file' + id].files[0];
                uploadFiles.id = id;

                let fileSize = 10458760; // 10MB
                const fileExt = uploadFiles.name.slice(uploadFiles.name.indexOf(".") + 1).toLowerCase(); // 파일 Name

                if ('png' != fileExt && 'gif' != fileExt && 'jpg' != fileExt) {
                    // png, gif, jpg만
                    alert(this.$t('sdp.support.message.fileAttachMsg2'));
                    return;
                }

                if (this.files.length >= 3) {
                    // MAX 3개까지
                    alert(this.$t("sdp.support.message.attachInfoMsg2"));
                    return;
                }

                if (uploadFiles.size > fileSize) {
                    // 10MB 까지
                    alert(this.$t("sdp.support.message.fileAttachMsg1"));
                    return;
                }

                this.files.push(uploadFiles);

            },
            convertFileSize(size) {
                //MB로 단위 변경
                var fileSize = size / 1024.0 / 1024.0;
                fileSize = fileSize.toFixed(2) + "MB";
                return fileSize;
            },
            addFiles() {
                var file0 = false;
                var file1 = false;
                var file2 = false;
                for(var i = 0; i < this.files.length; ++i) {
                    var file = this.files[i];
                    if(file.id == 0) {
                        file0 = true;
                    }
                    if(file.id == 1) {
                        file1 = true;
                    }
                    if(file.id == 2) {
                        file2 = true;
                    }
                }

                if(file0 == false) {
                    this.$refs.file0.click();
                    return
                }
                if(file1 == false) {
                    this.$refs.file1.click();
                    return
                }
                if(file2 == false) {
                    this.$refs.file2.click();
                    return
                }
            },
            removeFile(key, id) {
                // console.log(key, id)
                this.$refs['file' + id].value = ''
                this.files.splice(key, 1);
            },
            lineBreakCntt(cntt) {
                if(cntt != null && cntt != "") {
                    return cntt.split("\n").join("<br />");
                } else {
                    return "";
                }
            },
			esnFocus(esn) { // 2021.03.29 송준형 : C20210326_00833 - PC Website 1:1문의 시 Netflix 앱 입력 시 ESN 항목 추가
                if(esn == "esn1") {
                    this.esn1 = "";
                    //document.getElementById("esn1").focus();
                    setFocusScroll('#esn1');
                } else {
                    this.esn2 = "";
                    //document.getElementById("esn2").focus();
                    setFocusScroll('#esn2');
                }
			},
            inquiryCheck() {
                ui.loading.open();
                const vm = this;
                var email = "";
                var nChk = 0; // 약관동의 갯수

                if (vm.gdprFlag == "Y" && vm.gdprTermsData == false) {
                    alert(this.$t('sdp.member.message.termpolicyerror'));
                    ui.loading.close();
                    return;
                }

                // 필수값 validation
                // start-2020.06.12 송준형 : C20200615_50615 - PC website 웹접근성 심사 결과 대응
				if (vm.preEmail == null || vm.preEmail == "") {
                    if(vm.langCode == 'KOR') {
                        alert(this.$t('gwa.alt.support.message.preEmail'));
                    } else {
                        alert(this.$t('sdp.warn.com.input', { var1 : this.$t('sdp.support.message.recvEmail') }));
                    }
                    ui.loading.close();
                    //document.getElementById("preEmail").focus();
                    setFocusScroll('#preEmail');
                    return;
                }
                if (vm.endEmail == null || vm.endEmail == "") {
                    if(vm.langCode == 'KOR') {
                        alert(this.$t('gwa.alt.support.message.endEmail'));
					} else {
                        alert(this.$t('sdp.warn.com.input', { var1 : this.$t('sdp.support.message.recvEmail') }));
					}
                    ui.loading.close();
                    //document.getElementById("endEmail").focus();
                    setFocusScroll('#endEmail');
                    return;
                }
                if (vm.cateCode1 == null || vm.cateCode1 == "") {
                    if(vm.langCode == 'KOR') {
                        alert(this.$t('gwa.alt.support.message.cateCode1'));
                    } else {
                        alert(this.$t('sdp.warn.com.input', { var1 : this.$t('sdp.support.message.catType1') }));
                    }
                    ui.loading.close();
                    //document.getElementById("cateCode1").focus();
                    setFocusScroll('#cateCode1');
                    return;
                } else if(vm.cateCode1 == 1003 && vm.appName == '') {
                    // 서비스 -> 앱 스토어 / 콘텐츠일 경우 서비스명 필수값
                    if(vm.langCode == 'KOR') {
                        alert(this.$t('gwa.alt.support.message.serviceName'));
                    } else {
                        alert(this.$t('sdp.warn.com.input', { var1 : this.$t('sdp.support.message.serviceName') }));
                    }
                    ui.loading.close();
                    //document.getElementById("sAPP").focus();
                    setFocusScroll('#sAPP');
                    return;
                }
                if (vm.cateCode2 == null || vm.cateCode2 == "") {
                    if(vm.langCode == 'KOR') {
                        alert(this.$t('gwa.alt.support.message.cateCode2'));
                    } else {
                        alert(this.$t('sdp.warn.com.input', { var1 : this.$t('sdp.support.message.catType2') }));
                    }
                    ui.loading.close();
                   // document.getElementById("cateCode2").focus();
                    setFocusScroll('#cateCode2');
                    return;
                }
                if (vm.cateCode3 == null || vm.cateCode3 == "") {
                    if(vm.langCode == 'KOR') {
                        alert(this.$t('gwa.alt.support.message.cateCode3'));
                    } else {
                        alert(this.$t('sdp.warn.com.input', { var1 : this.$t('sdp.support.message.catType3').replace("<span class=\"dis-ib\">","").replace("</span>", "") }));
                    }
                    ui.loading.close();
                    //document.getElementById("cateCode3").focus();
                    setFocusScroll('#cateCode3');
                    return;
                }
                // start-2021.03.26 송준형 : C20210326_00833 - PC Website 1:1문의 시 Netflix 앱 입력 시 ESN 항목 추가
                if(vm.esnYn == "Y") {
                    var reg1 = /[~!@#$%^&*()_+|<>?:{}]/;
                    var reg2 = /^[A-Za-z0-9+]*$/;
                    var reg3 = /^[0-9+]*$/;

                    var invalidWarn = this.$t('sdp.warn.esn.invalid.001') + "\n" + this.$t('sdp.warn.esn.invalid.002');
                    var specialWarn = this.$t('sdp.warn.esn.special.001') + "\n" + this.$t('sdp.warn.esn.special.002');

                    if(vm.esn1 == "" || vm.esn2 == "") {
                        alert(this.$t('sdp.warn.com.input', { var1 : this.$t('sdp.support.message.esn') }));
                        ui.loading.close();
						if(vm.esn1 == "") {
                            vm.esnFocus("esn1");
						} else {
                            vm.esnFocus("esn2");
                        }
                        return;
					}

                    if(reg1.test(vm.esn1) || reg1.test(vm.esn2)) {
                        alert(specialWarn);
                        ui.loading.close();
                        if(reg1.test(vm.esn1)) {
                            vm.esnFocus("esn1");
						} else {
                            vm.esnFocus("esn2");
						}
                        return;
                    }

                    if(!reg2.test(vm.esn1) || !reg3.test(vm.esn2)) {
                        alert(invalidWarn);
                        ui.loading.close();
                        if(!reg2.test(vm.esn1)) {
                            vm.esnFocus("esn1");
                        } else {
                            vm.esnFocus("esn2");
                        }
                        return;
                    }

                    var engChk = vm.esn1.search(/[a-z]/ig);
                    var numChk = vm.esn1.search(/[0-9]/g);
                    if(engChk < 0 || numChk < 0) {
                        alert(invalidWarn);
                        ui.loading.close();
                        vm.esnFocus("esn1");
                        return;
					}

                    if(vm.esn1.length < 9 || vm.esn2.length < 11) {
                        alert(invalidWarn);
                        ui.loading.close();
                        if(vm.esn1.length < 9) {
                            vm.esnFocus("esn1");
                        } else {
                            vm.esnFocus("esn2");
                        }
                        return;
                    }
				}
                // end-2021.03.26 송준형 : C20210326_00833 - PC Website 1:1문의 시 Netflix 앱 입력 시 ESN 항목 추가
                if (vm.titleName == null || vm.titleName == "") {
                    if(vm.langCode == 'KOR') {
                        alert(this.$t('gwa.alt.support.message.titleName'));
                    } else {
                        alert(this.$t('sdp.warn.com.input', { var1 : this.$t('sdp.support.message.title') }));
                    }
                    ui.loading.close();
                    //document.getElementById("titleName").focus();
                    setFocusScroll('#titleName');
                    return;
                }
                if (this.checkSubjectLength(vm.titleName)) {
                    alert(this.$t('requisite.maxlength', { var1 : this.$t('sdp.support.message.title'), var2 : this.sMaxLength }));
                    ui.loading.close();
                    //document.getElementById("titleName").focus();
                    setFocusScroll('#titleName');
                    return;
                }
                if (vm.tCntt == null || vm.tCntt == "") {
                    if(vm.langCode == 'KOR') {
                        alert(this.$t('gwa.alt.support.message.tCntt'));
                    } else {
                        alert(this.$t('sdp.warn.com.input', { var1 : this.$t('sdp.support.message.content') }));
                    }
                    ui.loading.close();
                    //document.getElementById("tCntt").focus();
                    setFocusScroll('#tCntt');
                    return;
                }
                // start-2020.07.27 송준형 : C20200717_71055 - PC Website 1:1문의 개선(1:1문의 입력시 최소 Byte 설정)
                if (this.getStrByte(vm.tCntt) < vm.cnttMinLength || this.getStrByte(vm.tCntt) > vm.tMaxLength) {
                    var cnttMsg1 = this.$t('sdp.inquiry.message.cnttLength1');
                    var cnttMsg2 = this.$t('sdp.inquiry.message.cnttLength2');
                    alert(cnttMsg1 + "\n\n" + cnttMsg2);
                    ui.loading.close();
                    //document.getElementById("tCntt").focus();
                    setFocusScroll('#tCntt');
                    return;
				}
                // end-2020.07.27 송준형 : C20200717_71055 - PC Website 1:1문의 개선(1:1문의 입력시 최소 Byte 설정)
                // end-2020.06.12 송준형 : C20200615_50615 - PC website 웹접근성 심사 결과 대응

                // start-2023.12.12 송준형 : REQSDP-2939 - pc mall 1:1 문의 - 비회원 문의 시 약관 확인 건(2023 ISO 지적사항 f/up)
                if (vm.langCode == 'KOR') {
                    // 한국
                    if (vm.agreeKOR1 == false) {
                        // 개인정보 수집 이용
                        // this.termValidate = "agreeKOR1";
                        // ui.loading.close();
                        // ui.popup.open("popupTermValidation");
                        alert(this.$t('refund.agree.message.confirm'));
                        ui.loading.close();
                        setFocusScroll('#agreeKOR1');
                        return;
                    }
                } else {
                    // 한국 이외 국가
                    if (vm.gdprFlag == "Y") {
                        // gdpr 국가
                        if (vm.agreeGdpr == false) {
                            // this.termValidate = "agreeGdpr";
                            // ui.loading.close();
                            // ui.popup.open("popupTermValidation");
                            alert(this.$t('sdp.memberterm.policy.gdpr.inquiry'));
                            ui.loading.close();
                            setFocusScroll('#agreeGdpr');
                            return;
                        }
                        if (vm.agreeGdprTerms == false) {
                            alert(this.$t('sdp.memberterm.policy.gdpr.inquiry'));
                            ui.loading.close();
                            setFocusScroll('#agreeGdprTerms');
                            return;
                        }
                    } else {
                        if (vm.agreeNotKOR == false) {
                            // this.termValidate = "agreeNotKOR";
                            // ui.loading.close();
                            // ui.popup.open("popupTermValidation");
                            alert(this.$t('sdp.memberterm.policy'));
                            ui.loading.close();
                            setFocusScroll('#agreeNotKOR');
                            return;
                        }
                    }
                }

                // start-2021.04.20 송준형 : C20210419_10922 - Global 1:1문의 시 디바이스정보 자동등록 기능 개선
                if(vm.maddrNoticeYn == "N" && (vm.macAddress == "" || vm.modelName == "")) {
                    var maddrNoticeMsg = this.$t('sdp.inquiry.message.maddr.001') + "\n" + this.$t('sdp.inquiry.message.maddr.002');
                    alert(maddrNoticeMsg);
                    vm.maddrNoticeYn = "Y";
                    ui.loading.close();

                    if(vm.macAddress == "") {
                        setFocusScroll('#sMacAdd2');
                    } else {
                        setFocusScroll('#sModel2');
                    }
                    return;
                }
                // end-2021.04.20 송준형 : C20210419_10922 - Global 1:1문의 시 디바이스정보 자동등록 기능 개선
                // end-2023.12.12 송준형 : REQSDP-2939 - pc mall 1:1 문의 - 비회원 문의 시 약관 확인 건(2023 ISO 지적사항 f/up)

                email = vm.preEmail + "@" + vm.endEmail;

                vm.inquiryEmailCheck(email);

            },
            inquiryEmailCheck (email) {
                const params = {
                    email : email
                };

                var resultFlag;

                this.$axios.post("/api/inquiry/emailValidation.ajax", qs.stringify(params)).then((result) => {

                    resultFlag = result.data.resultFlag;
                    if (!resultFlag) {
                        // 비정상이메일
                        alert(this.$t('sdp.support.message.email') + " : " + this.$t('sdp.member.message.emailfail2'));
                        ui.loading.close();
                        document.getElementById("preEmail").focus();
                        return;
                    }
                    this.inquirySetting(email);

                }).catch((error) => {
                    alert("error");
                });

            },
            inquirySetting(email) {

                const vm = this;
                vm.loadingYn = "Y";

                let formData = new FormData();

                // file Setting
                for (var i = 0; i < vm.files.length; i++) {
                    let file = vm.files[i];

                    formData.append("files", file);
                }

                var macAddressUpper = vm.macAddress.toUpperCase();

                var esn = "";
                if(vm.esnYn == "Y") { // 2021.03.29 송준형 : C20210326_00833 - PC Website 1:1문의 시 Netflix 앱 입력 시 ESN 항목 추가
                    esn = vm.esn1 + "=" + vm.esn2;
				}

                formData.append("email", email);
                formData.append("catType1", vm.cateCode1);
                formData.append("catType2", vm.cateCode2);
                formData.append("catType3", vm.cateCode3);
                formData.append("titleName", vm.titleName);
                formData.append("cntt", vm.tCntt);
                formData.append("tvModel", vm.modelName);
                formData.append("maddr", macAddressUpper);
                formData.append("esn", esn); // 2021.03.05 송준형 : C20210219_83324 - 1:1문의 페이지에서 Netflix앱 입력 시 ESN 항목 추가
                formData.append("purchaseAppInput", $('#sAPP').val()); // autoComplete 처리
                formData.append("agreeKOR1", vm.agreeKOR1);
                formData.append("agreeKOR2", vm.agreeKOR2);
                formData.append("agreeNotKOR", vm.agreeNotKOR);
                formData.append("agreeGdpr", vm.agreeGdpr);
                formData.append("macSelectChk", vm.macSelectChk);
                formData.append("modelSelectChk", vm.modelSelectChk);
                formData.append("totalFileNum", vm.files.length);
                // 2019.11.21 김남중 - PC Website 1:1 문의 시 이메일 Validation 체크 기능 추가 - N20191111_03615
                formData.append("facebkFlag", vm.facebkFlag);
                formData.append("thirdpartyFlag", vm.thirdpartyFlag);


                var url = "";
                /*var params = {};*/
                var header = {};

                if (this.memberYn == 'Y') {
                    url = "/api/inquiry/inquiryRegisterMember.ajax";
                } else {
                    url = "/api/inquiry/inquiryRegisterNonMember.ajax";
                }

                header = {
                    headers : {
                        'Content-Type': 'multipart/form-data'
                    }
                };

                vm.InquiryRegister(url, formData, header);
            },
            InquiryRegister(url, formData, header) {

                this.$axios.post(url, formData, header).then((result) => {
                    ui.loading.close();

                    const successFlag = result.data.message;
                    const codeFlag    = result.data.code; // 2019.11.21 김남중 - PC Website 1:1 문의 시 이메일 Validation 체크 기능 추가 - N20191111_03615

                    console.log("successFlag" + successFlag);
                    if (successFlag) {
                    	//start- 2019.11.21 김남중 - PC Website 1:1 문의 시 이메일 Validation 체크 기능 추가 - N20191111_03615
                    	if (codeFlag == "EMAIL") {
                    		console.log("등록실패");
                            this.loadingYn = "N";
                    		alert(this.$t('sdp.warn.com.input', { var1 : this.$t('sdp.support.message.idOrEmailId') }));
                    		setFocusScroll('endEmail');
                    	} else {
                    	//end- 2019.11.21 김남중 - PC Website 1:1 문의 시 이메일 Validation 체크 기능 추가 - N20191111_03615
	                        // 성공할 경우
	                        console.log("등록완료");
	
	                        // Vuex 초기화
	                        this.$store.state.inquiryCateCode1 = "";
	                        this.$store.state.inquiryCateCode2 = "";
	                        this.$store.state.inquiryCateCode3 = "";
	
	                        ui.popup.open("popupRegisterComp");
                    	}
                    } else {
                        // 실패할 경우
                        console.log("등록실패");
                        this.loadingYn = "N";
                        //start- 2019.11.21 김남중 - PC Website 1:1 문의 시 이메일 Validation 체크 기능 추가
                    	if (codeFlag == "EMAIL") {
                    		alert(this.$t('sdp.warn.com.input', { var1 : this.$t('sdp.support.message.idOrEmailId') }));
                    		setFocusScroll('#preEmail');
                    	} else if(codeFlag == "FILEEXT") { // 2022.05.23 송준형 : REQSDP-1632 - 2022 ISAC 대응 - pc mall(S2. WS 2-3-2)
                            alert(this.$t('sdp.support.message.fileAttachMsg2'));
						} else {
                    	//end- 2019.11.21 김남중 - PC Website 1:1 문의 시 이메일 Validation 체크 기능 추가
                        	alert(this.$t('sdp.err.cm.authentication'));
                    	}
                    }
                }).catch((error) => {
                	dimmer.init(); // N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의-문의등록후dimmer처리되어 추가) 2019.07.11 김남중
                    ui.loading.close();
                    this.loadingYn = "N";
                    alert("error");
                });
            },
            inquiryCancel() {
            	// N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의) 2019.07.11 김남중
            	dimmer.init();
            	console.log('prevPageMove');
    			this.$router.go(-1); // 이전 페이지 이동
    			//const r = { path : "/main" }; this.$router.push(r);
            },
            retrieveMain() {
				// N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의-문의등록후dimmer처리되어 추가, InquiryRegisterConfirmPop.vue 있는 method 가져옴.) 2019.07.11 김남중
				const r = { path : `/main`};
                this.$router.push(r);
			}
        },
        lineBreakCntt2(cntt) {
            if(cntt != null && cntt != "") {
            	var cntt = cntt.join("<br />");
            	cntt = cntt + this.$t('sdp.inpuiry.message.Israel.002') + "<br />";
            	cntt = cntt + this.$t('sdp.inpuiry.message.Israel.003') + "<br />";
            	cntt = cntt + this.$t('sdp.inpuiry.message.Israel.004') + "<br />";
            	cntt = cntt + this.$t('sdp.inpuiry.message.Israel.005') + "<br />";
            	cntt = cntt + this.$t('sdp.inpuiry.message.Israel.006') + "<br />";
            	return cntt;
            } else {
                return "";
            }
		},
        mounted() {

            const vm = this;
            /*vm.$nextTick(function() {
                ui.init();
            });*/

            if (typeof vm.$route.query.cateCode1 == 'undefined') {
                vm.cateCode1 = "";
            } else {
                vm.cateCode1 = vm.$route.query.cateCode1;
            }
            if (typeof vm.$route.query.cateCode2 == 'undefined') {
                vm.cateCode2 = "";
            } else {
                vm.cateCode2 = vm.$route.query.cateCode2;
            }

            if (typeof vm.$route.query.cateCode3 == 'undefined') {
                vm.cateCode3 = "";
            } else {
                vm.cateCode3 = vm.$route.query.cateCode3;
            }

            if (vm.cateCode3 != "") {
                vm.changeType();
            }

            var qrcodeData = this.$route.query.qrcodedata;

            const params = {
                cateCode1 : vm.cateCode1,
                cateCode2 : vm.cateCode2,
                cateCode3 : vm.cateCode3,
                qrcodeData: qrcodeData
            };

            this.$axios.post("/api/inquiry/retrieveInquiryRegister.ajax", qs.stringify(params)).then((result) => {
                vm.memberYn = result.data.memberYn;
                vm.userId = result.data.userId;
                // [ CSR_ID : 862834 ] PC Website 1:1 문의 시 이메일 Validation 체크 기능 추가 - N20191028_09768
                vm.facebkFlag = result.data.facebkFlag;
                vm.thirdpartyFlag = result.data.thirdpartyFlag;

                // N20200527_08644-말레이시아 PC Website 1:1문의 팝업 원복 건 2020.05.29 송준형
                // if(vm.memberYn == 'Y' && vm.cntryCode == 'MY') {
                //     vm.noticeYn = "Y";
				// }
                
                if (vm.memberYn == 'Y') {
                	// start - N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의) 2019.07.11 김남중
					if(vm.noticeYn == 'Y') { // N20200420_06622-[UI기획]PC Website 1:1문의 대응 지연 팝업 문구 안내 건 2020.04.20 송준형
                        dimmer.open('dimmer-popup', 0.6);
                        ui.popup.open("popupNotice");
					} else {
                        ui.popup.close("popupConfirm");
                        dimmer.close('dimmer-popup', 0.6);
					}
                	// end - N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의) 2019.07.11 김남중
                	
                	vm.email = result.data.userEmail;
                    var preEmail = vm.email.split("@")[0];
                    var endEmail = vm.email.split("@")[1];

                    vm.preEmail = preEmail;
                    vm.endEmail = endEmail;

                    vm.maddrList = result.data.maddrList;
                    vm.selectedMaddr = result.data.selectedMaddr; // 2021.04.19 송준형 : C20210419_10922 - Global 1:1문의 시 디바이스정보 자동등록 기능 개선
                } else {
                	if (vm.cntryCode != 'IL') { // PC Website UI/UX개선 - N20190904_01409 : 2019.09.26 김남중
	                	// start - N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의) 2019.07.11 김남중
	                	dimmer.open('dimmer-popup', 0.6);
	                	ui.popup.open("popupConfirm");
	                	// end - N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의) 2019.07.11 김남중
                	}
                }

                vm.serviceList = result.data.serviceList;

                if(result.data.categoryList != null && result.data.categoryList.length > 0) {
                    vm.categoryList = result.data.categoryList;
                }

                if(result.data.typeList != null && result.data.typeList.length > 0) {
                    vm.typeList = result.data.typeList;
                }

                vm.perTerm = result.data.perTerm;
                vm.perTermSize = result.data.perTermSize;
                vm.prvTerm = result.data.prvTerm;
                vm.prvTermSize = result.data.prvTermSize;
                vm.langCode = result.data.langCode;
                vm.gdprFlag = result.data.gdprFlag;
                vm.gdprTermsData = result.data.gdprTermsData;

                // Info Seq No (FAQ)
                vm.macInfoSeq = result.data.macInfoSeq;
                vm.modelInfoSeq = result.data.modelInfoSeq;
                vm.esnInfoSeq = result.data.esnInfoSeq; // 2021.03.09 송준형 : C20210219_83324 - 1:1문의 페이지에서 Netflix앱 입력 시 ESN 항목 추가

				vm.inquiryChannelCode = result.data.inquiryChannelCode; // 2021.04.08 송준형 : C20210408_06760 - 1:1 문의 서비스 항목에 LG Channel 추가 요청드립니다.
				vm.faqChannelCode = result.data.faqChannelCode; // 2021.04.08 송준형 : C20210408_06760 - 1:1 문의 서비스 항목에 LG Channel 추가 요청드립니다.
                vm.channelDownloadUrl = result.data.channelDownloadUrl; // 2021.04.13 송준형 : C20210408_06760 - 1:1 문의 서비스 항목에 LG Channel 추가 요청드립니다.

                var qrcode = result.data.qrcode;
                if(qrcode != undefined || qrcode != null) {
                    vm.macAddress = qrcode.macAddress;
                    vm.modelName = qrcode.modelName;
                }

                if (vm.$route.query.cateCode1 == 1003) { // 앱 스토어 / 콘텐츠일 경우 서비스명 필수값
                    vm.appStoreYn = 'Y'
                } else {
                    vm.appStoreYn = 'N'
                }

                vm.$nextTick(function() {
                    ui.init();
                    ui.faqAccordion.init();
                    dimmer.init(); // N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의) 2019.07.11 김남중

                    // start-2021.04.19 송준형 : C20210419_10922 - Global 1:1문의 시 디바이스정보 자동등록 기능 개선
                    if(vm.selectedMaddr != "") {
                        vm.macAddress = vm.selectedMaddr;
                        vm.macSelectChk = vm.selectedMaddr;

                        const params = {
                            maddr: vm.macAddress,
                        };

                        this.$axios.post("/api/inquiry/retrieveModelList.ajax", qs.stringify(params)).then((result) => {
                            vm.modelList = result.data.modelList;
                            if(vm.modelList.length != 0) {
                                vm.modelSelectChk = vm.modelList.modelName;
                                vm.modelName = vm.modelList.modelName;
							}
                        }).catch((err) => {
                            alert("error : " + err);
                        });
                    }
                    // end-2021.04.19 송준형 : C20210419_10922 - Global 1:1문의 시 디바이스정보 자동등록 기능 개선

					vm.tCntt = this.$t('sdp.inquiry.content.info'); // 2022.09.02 송준형 : REQSDP-1850 - [PC Mall] 1:1문의 입력란 가이드 추가
                    vm.tCnttLength = this.getStrByte(vm.tCntt); // 2022.09.02 송준형 : REQSDP-1850 - [PC Mall] 1:1문의 입력란 가이드 추가

                    $("#sAPP").autocomplete({
                        appendTo: ".ac-search-static2",
                        source : vm.completeKeywordList,
                        messages: {
                            noResults: '',
                            results: function() {}
                        }
                    });

                    ui.searchAll.closeCallback = function() {
                        vm.searchText = '';
                    }
                });

            }).catch((error) => {
            	dimmer.init(); // N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의-문의등록후dimmer처리되어 추가) 2019.07.11 김남중
            	alert("error");
            });
            
            // N20190710_04315-PC 웹사이트 1:1문의 화면 이슈(1:1문의) 2019.07.11 김남중
            if (vm.memberYn == 'Y' && vm.noticeYn == 'N') { // N20200420_06622-[UI기획]PC Website 1:1문의 대응 지연 팝업 문구 안내 건 2020.04.20 송준형
            	dimmer.close('dimmer-popup', 0.6);
			}

			if (vm.$route.query.confirmPopYn == "Y") { // 2024.06.18 송준형 : REQSDP-4717 - PC Mall 웹접근성 심사 결과 대응_2024년
                setFocusScroll('#skipNav');
			}
        }
    }
</script>